<template lang="pug">
  a.sub-collection-tile(:href="`/collections/${subCollection.collection.handle}`" data-aos="zoom-in-up" :style="`--delay: ${transitionDelay}s`")
    .collection-super__sub-collection__image-wrapper
      img.collection-super__sub-collection__image(v-if="image" v-lazy="image" :alt="imageAlt")
      slot(name="svg" v-else)
    h2.collection-super__sub-collection__title
      span.collection-super__sub-collection__title-span {{ subCollection.collection.title }}
        span.collection-super__sub-collection__icon
          icon(name='chevron-right' size='18px')
</template>

<script>
  import Icon from 'scripts/components/basic/Icon.vue';
  import { getSizedImageUrl } from 'scripts/filters/images.js';

  import AOS from 'aos';

  export default {
    name: 'SubCollectionTile',
    components: { Icon },
    props: {
      subCollection: Object,
      columnIndex: Number,
    },
    data() {
      return {
        imageSize: '500x',
        delayIncrement: 0.05
      }
    },
    computed: {
      image () {
        let image = this.subCollection.collection.image;
        return image ? getSizedImageUrl(image.src, this.imageSize) : null;
      },
      imageAlt () {
        let image = this.subCollection.collection.image;
        return image ? image.alt : null;
      },
      transitionDelay () {
        return this.columnIndex * this.delayIncrement;
      }
    },
    created () {
      AOS.init();
    },
  };
</script>

<style scoped lang="scss">
</style>
